import layout from './LoginView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import LoginViewModel from "@/ViewModels/Views/LoginViewModel";

export default class LoginView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: LoginViewModel, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }
        
        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('LoginView', LoginView, 'RADPresentation.HTMLClient.DefaultViewExtensions');